import { ListChildComponentProps } from 'react-window';

const UngroupedRowV3 = (props: ListChildComponentProps) => {
  const { index, style, data } = props;
  const { items, renderItem } = data;
  const rowData = items[index];

  const inlineStyle = {
    ...style,
    listStyle: 'none',
  };

  return renderItem({
    item: rowData,
    isNested: true,
    style: inlineStyle,
  });
};

export default UngroupedRowV3;
